import { ArrowLeft, ArrowRight } from "lucide-react";
import Header from "@/components/site/Header";
import Services from "@/components/site/Services";
import Footer from "@/components/site/Footer";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";
import { useGoTo, useHashScroll } from "@/lib/navigation";

export default function ServicesPage() {
  const { t } = useLang();
  const s = t.services;
  const goTo = useGoTo();
  useHashScroll();

  return (
    <div data-testid="services-page" className="bg-cream-50 text-ink-900 min-h-screen">
      <Header />
      <main>
        <Services page />
        <section data-testid="services-cta" className="bg-white border-t border-ink-900/8">
          <div className="container-x py-20 sm:py-24 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-ink-900 tracking-tight leading-tight">
                {s.ctaTitle}
              </h2>
              <p className="mt-4 text-base sm:text-lg text-ink-500 leading-relaxed max-w-2xl">{s.ctaSub}</p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
              <Button
                data-testid="services-cta-book"
                onClick={() => goTo("#book")}
                className="group bg-brand-500 text-white hover:bg-brand-600 hover:-translate-y-0.5 transition-all duration-300 rounded-sm h-12 px-7 text-sm tracking-wide font-semibold shadow-sm"
              >
                {s.ctaBtn}
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
              <button
                data-testid="services-back-home"
                onClick={() => goTo("/")}
                className="inline-flex items-center gap-2 h-12 px-4 text-sm font-medium text-ink-600 hover:text-brand-600 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                {s.backHome}
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
